import { render } from "./DataPlanInformation.vue?vue&type=template&id=50471ec1&scoped=true"
import script from "./DataPlanInformation.vue?vue&type=script&lang=js"
export * from "./DataPlanInformation.vue?vue&type=script&lang=js"

import "./DataPlanInformation.vue?vue&type=style&index=0&id=50471ec1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50471ec1"]])

export default __exports__